import prevIcon from "./prev.png";
import nextIcon from "./next.png";
import ExpiredImg from "./expired.png";
import ArrowUp from "./icons8-arrow-up-48.png";
import ArrowDown from "./icons8-arrow-down-48.png";
import MintPageBanner from "./mintPageBanner.png";
import MXLogo from "./mxs_logo_icon_white.png";
import NA from "./NA.png";
import OptionsImg from "./options.png";
import walletImg from "./wallet.png";
import PlusPng from "./plusIcon.png";

export {
  prevIcon,
  nextIcon,
  ExpiredImg,
  ArrowUp,
  ArrowDown,
  MintPageBanner,
  MXLogo,
  NA,
  OptionsImg,
  walletImg,
  PlusPng
};
